export default "__VITE_ASSET__BAtG7WmN__"